module.exports = "/_next/static/images/2edde169466b93763d64f4ef1a3cb2ba-10-million-purple.svg.webp";